const routes = [
  {
    path: "/student/autismsurveillancenetwork",
    name: "autismsurveillancenetwork",
    component: () => import("@/views/student/AutismSurveillanceNetwork/Main.vue")
  },  
  {
    path: "/student/autismsurveillancenetwork/detail/:studentSie",
    name: "autismsurveillancenetworkDetail",
    component: () => import("@/views/student/AutismSurveillanceNetwork/StudentDetail.vue")
  },  
];

export default routes;
